export const displayTime = (time: number) => {
  const hours = time / 60;
  const residueMinutes = time % 60;
  const days = hours / 24;
  const residueHours = hours % 24;

  return `${days | 0} dias ${residueHours | 0} hr ${residueMinutes} m`;
};
